const revLetters = 'ABCDEFGHJKMNPRTUVWXYZ';
/** Translate a Puffco revision string to a number */
export const revisionStringToNumber = (s) => {
    if (typeof s !== 'string') {
        return NaN;
    }
    if (s === 'X*') {
        return 0;
    }
    if (s.toLowerCase().startsWith('inf')) {
        return Infinity;
    }
    const upper = s.toUpperCase();
    let shift = -1;
    for (const u of upper) {
        const letterIndex = revLetters.indexOf(u);
        if (letterIndex < 0) {
            return NaN;
        }
        shift = (shift + 1) * revLetters.length + letterIndex;
    }
    return shift + 1;
};
/** Translate a number to a Puffco revision string */
export const revisionNumberToString = (value) => {
    if (typeof value !== 'number' || !(value >= 0)) {
        return `${value}`;
    }
    if (value === 0) {
        return 'X*';
    }
    let shift = value - 1;
    let out = '';
    while (shift >= 0) {
        out = revLetters[shift % revLetters.length] + out;
        shift = Math.floor(shift / revLetters.length) - 1;
    }
    return out;
};
//# sourceMappingURL=version-string.js.map